import React from 'react';
import { Typography } from '@material-ui/core';
import { LABEL_WIDTH } from '../wizard-ui/constants';

const PillLabel: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({
    children,
    style
}) => (
    <Typography
        style={{
            width: LABEL_WIDTH,
            flexShrink: 0,
            padding: '7px 14px',
            border: '1px solid #b2dfd6',
            borderRadius: 8,
            background: '#e8f8f5',
            fontFamily: "'DM Mono', monospace",
            fontSize: 13,
            fontWeight: 500,
            color: '#1eb89a',
            boxSizing: 'border-box',
            lineHeight: '20px',
            ...style
        }}>
        {children}
    </Typography>
);

export default PillLabel;
